import modalTips from './modalTips.vue'
export default modalTips


// WEBPACK FOOTER //
// ./src/components/modal/modalTips/index.js